import React from "react";
import { Box } from "@mui/material";
import { TOKENS } from "./tokens";

/**
 * Inline plan tag. Falls back to Community styling for unknown plans.
 * `mini` shrinks height/padding for use inside dense rows.
 */
const PlanChip = ({ plan, mini = false }) => {
  const known = TOKENS.plans[plan];
  const style = known || TOKENS.plans.Enterprise;
  const label = plan || "Community";
  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        height: mini ? 20 : 24,
        px: mini ? "8px" : "10px",
        borderRadius: 999,
        background: style.bg,
        color: style.ink,
        border: `1px solid ${style.border}`,
        fontSize: mini ? 11 : 12,
        fontWeight: 600,
        lineHeight: 1,
        letterSpacing: "0.01em",
      }}
    >
      {label}
    </Box>
  );
};

export default PlanChip;
